import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';

import {HandlePropChanges} from '../shared';

@Directive({
  selector: `
    a[mz-button],
    a[mzButton],
    button[mz-button],
    button[mzButton]`,
})
export class MzButtonDirective extends HandlePropChanges implements OnInit {
  @Input() disabled: boolean;
  @Input() flat: boolean;
  @Input() float: boolean;
  @Input() large: boolean;
  @Input() noWaves: boolean;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    super();
  }

  ngOnInit() {
    this.initHandlers();
    this.initMaterialize();
    super.executePropHandlers();
  }

  initHandlers() {
    this.handlers = {
      disabled: () => this.handleDisabled(),
      flat: () => this.handleFlat(),
      float: () => this.handleFloat(),
      large: () => this.handleLarge(),
      noWaves: () => this.handleNoWaves(),
    };
  }

  initMaterialize() {
    this.renderer.addClass(this.elementRef.nativeElement, 'btn');
  }

  handleDisabled() {
    if (this.disabled) {
      this.renderer.addClass(this.elementRef.nativeElement, 'disabled');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'disabled');
    }
  }

  handleFlat() {
    if (this.flat) {
      this.renderer.addClass(this.elementRef.nativeElement, 'btn-flat');
      this.renderer.removeClass(this.elementRef.nativeElement, 'btn');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'btn-flat');
      this.renderer.addClass(this.elementRef.nativeElement, 'btn');
    }
  }

  handleFloat() {
    if (this.float) {
      this.renderer.addClass(this.elementRef.nativeElement, 'btn-floating');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'btn-floating');
    }
  }

  handleLarge() {
    if (this.large) {
      this.renderer.addClass(this.elementRef.nativeElement, 'btn-large');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'btn-large');
    }
  }

  handleNoWaves() {
    if (this.noWaves) {
      this.renderer.removeClass(this.elementRef.nativeElement, 'waves-effect');
    } else {
      this.renderer.addClass(this.elementRef.nativeElement, 'waves-effect');
    }

    if (!this.flat) {
      this.renderer.removeClass(this.elementRef.nativeElement, 'waves-light');
    }
  }
}
